import angular from 'angular';
import template from './self-video-expand-btn.html';
import * as call from '../../../modules/call';
import * as localMedia from '../../../modules/local-media';
const LOCAL_STORAGE_PARAM_EXPAND_UNDERSTOOD = 'self-video-expanded-understood';
class SelfVideoExpandBtnController {
    constructor($scope, VideoProviderFactory, selfMicrophoneRenderer, trackingFactory, $state, $ngRedux) {
        this.$scope = $scope;
        this.VideoProviderFactory = VideoProviderFactory;
        this.selfMicrophoneRenderer = selfMicrophoneRenderer;
        this.trackingFactory = trackingFactory;
        this.$state = $state;
        this.$ngRedux = $ngRedux;
        this.VideoProviderFactory.decorateScope(this);
    }
    $onInit() {
        this.haveReadInfo =
            window.localStorage.getItem(LOCAL_STORAGE_PARAM_EXPAND_UNDERSTOOD) ===
                'true';
    }
    onMicInit() {
        setTimeout(() => this.selfMicrophoneRenderer.initCanvasContexts());
    }
    closeInfoMessage() {
        this.haveReadInfo = true;
        window.localStorage.setItem(LOCAL_STORAGE_PARAM_EXPAND_UNDERSTOOD, 'true');
    }
    toggleAudio($event, isEnabled) {
        this.$ngRedux.dispatch(localMedia.actions.toggleAudio(isEnabled));
        $event.stopPropagation();
    }
    toggleVideo($event, isEnabled) {
        this.$ngRedux.dispatch(localMedia.actions.toggleVideo(isEnabled));
        $event.stopPropagation();
    }
    expand() {
        this.$ngRedux.dispatch(call.actions.showSelfPreview());
        if (this.$state.$current.name === 'account.dashboard' &&
            !this.VideoProviderFactory.activeProvider.isInCall) {
            this.trackingFactory.global.trackButtonClick({
                button_action: 'expand user preview',
                button_text: 'expand',
                button_type: 'button',
                context: 'dashboard',
            });
        }
    }
}
const selfVideoExpandBtnComponent = {
    template,
    bindings: {
        expanded: '<',
        hasAudio: '<',
        hasVideo: '<',
        isSmall: '<',
        peopleCount: '<',
    },
    controller: SelfVideoExpandBtnController,
};
export default angular
    .module('doxy.videoChat.callFrames.selfVideoExpandBtn', [])
    // self-video-expand-btn
    .component('selfVideoExpandBtn', selfVideoExpandBtnComponent).name;
